/* eslint-disable no-alert */
import * as React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { Dropdown } from '../Dropdown';
import { Button } from '../Button';

const meta: Meta<typeof Dropdown> = {
  title: 'Components/Dropdown',
  component: Dropdown,
};

export default meta;
type Story = StoryObj<typeof Dropdown>;

export const Default: Story = {
  render(props) {
    return (
      <Dropdown title="I'm a dropdown" {...props}>
        <a href="https://example.com" rel="noreferrer" target="_blank">
          Foo
        </a>
        <Button variant="anchor" href="https://google.com" target="_blank">
          Bar
        </Button>
        <button onClick={() => alert('Foo')}>Foo</button>
        <button onClick={() => alert('Bar')}>Bar</button>
        <hr />
        <button disabled onClick={() => alert('Baz')}>
          Baz
        </button>
      </Dropdown>
    );
  },
};
